module.exports = __webpack_public_path__ + "themes/mf/sound/audio-sprite.json";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/sound/audio-sprite.json
// module id = 47
// module chunks = 3